import "./About.css";

function About({ darkMode }) {
    return (
        <section
            className={`about-section ${darkMode ? "dark" : ""}`}
            id="about"
        >
            <div className="about-container">
                <span className="about-tag">ABOUT ME</span>

                <h1>
                    Building software with curiosity, adaptability, and a
                    passion for emerging technology.
                </h1>

                <div className="about-content">
                    <p>
                        I'm a Software Engineering graduate from the University
                        of Calgary with a minor in Mechatronics. I enjoy
                        building across disciplines, from embedded systems and
                        mobile apps to AI-driven experiences and interactive
                        software.
                    </p>

                    <p>
                        What drives me most is the constant evolution of
                        technology. I enjoy learning unfamiliar systems,
                        experimenting with new tools, and adapting quickly to
                        challenging environments.
                    </p>

                    <p>
                        I’m especially interested in software that blends strong
                        engineering with meaningful user experiences. Whether
                        it’s firmware, full-stack applications, or immersive
                        interfaces, I like creating things that feel impactful
                        and thoughtfully designed.
                    </p>

                    <p>
                        This portfolio is a reflection of that mindset, always
                        evolving, always improving, and always exploring what’s
                        next.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default About;
